(() => {
  const stories = document.querySelectorAll('[data-ps-ad-story]');
  stories.forEach((story) => {
    const slides = Array.from(story.querySelectorAll('[data-ps-ad-slide]'));
    const panels = Array.from(story.querySelectorAll('[data-ps-ad-panel]'));
    const dots = Array.from(story.querySelectorAll('[data-ps-ad-dot]'));
    if (!slides.length || slides.length !== panels.length) return;
    let active = 0;
    let timer;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const current = index === active;
        slide.classList.toggle('is-active', current);
        slide.setAttribute('aria-hidden', String(!current));
      });
      panels.forEach((panel, index) => {
        const current = index === active;
        panel.classList.toggle('is-active', current);
        panel.hidden = !current;
      });
      dots.forEach((dot, index) => {
        const current = index === active;
        dot.classList.toggle('is-active', current);
        if (current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      if (!reduceMotion.matches && !document.hidden) timer = window.setInterval(() => show(active + 1), 4800);
    };
    story.querySelector('[data-ps-ad-prev]')?.addEventListener('click', () => { show(active - 1); start(); });
    story.querySelector('[data-ps-ad-next]')?.addEventListener('click', () => { show(active + 1); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    story.addEventListener('mouseenter', stop);
    story.addEventListener('mouseleave', start);
    story.addEventListener('focusin', stop);
    story.addEventListener('focusout', (event) => { if (!story.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    reduceMotion.addEventListener?.('change', start);
    show(0);
    start();
  });

  const sticky = document.querySelector('[data-ps-ad-sticky]');
  const hero = document.querySelector('.ps-ad__hero');
  if (sticky && hero) {
    const link = sticky.querySelector('a');
    const updateSticky = () => {
      const visible = hero.getBoundingClientRect().bottom <= 0;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      if (link) link.tabIndex = visible ? 0 : -1;
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  }
})();
